import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '@/utils/tracking';
import { useMarketingTracking } from '@/hooks/useMarketingTracking';

interface TrackingEventsProps {
  children: React.ReactNode;
}

export const TrackingEvents = ({ children }: TrackingEventsProps) => {
  const location = useLocation();
  const { trackFormationInteraction, trackCTAClick } = useMarketingTracking();

  // Track page views
  useEffect(() => {
    const pageTitle = document.title;
    trackPageView(location.pathname, pageTitle);
  }, [location]);

  // Track formation interactions
  useEffect(() => {
    const handleFormationCardClick = (event: Event) => {
      const target = event.target as HTMLElement;
      const formationCard = target.closest('[data-formation-id]');
      
      if (formationCard) {
        const formationId = formationCard.getAttribute('data-formation-id');
        const formationTitle = formationCard.getAttribute('data-formation-title');
        
        if (formationId && formationTitle) {
          trackFormationInteraction('view', formationId, formationTitle);
        }
      }
    };

    const handleCTAClick = (event: Event) => {
      const target = event.target as HTMLElement;
      const button = target.closest('button, a');
      
      if (button) {
        const ctaText = button.textContent?.trim();
        const ctaType = button.getAttribute('data-cta-type') || 'unknown';
        
        if (ctaText) {
          trackCTAClick(ctaText, location.pathname);
        }
      }
    };

    // Add event listeners
    document.addEventListener('click', handleFormationCardClick);
    document.addEventListener('click', handleCTAClick);

    return () => {
      document.removeEventListener('click', handleFormationCardClick);
      document.removeEventListener('click', handleCTAClick);
    };
  }, [location, trackFormationInteraction, trackCTAClick]);

  return <>{children}</>;
};